module.exports = __webpack_public_path__ + "img/03.d8a9991d.jpg";